<template>
  <div class="flex-1">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Flex1'
}
</script>

<style scoped></style>
